module.exports = __webpack_public_path__ + "static/media/SMG-web-Checkotu-4.85f11a7e.png";


//////////////////
// WEBPACK FOOTER
// ./src/images_hd/mcGee/SMG-web-Checkotu-4.png
// module id = 580
// module chunks = 0